var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.value || _vm.value === "[]"
        ? _c("em", [_vm._v("Aucune affectation disponible")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.parseValue(), function(item, index) {
        return _vm.value
          ? _c("affectation-transformateur", {
              key: index,
              attrs: {
                name: "affectation-transfo",
                index: index,
                datas: item,
                prefixIt: _vm.prefix
              }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10a7aa4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a7aa4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/AffectationsTransformateur.vue
// module id = 577
// module chunks = 0